var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container",style:({
    '--source-color-dark': ("var(--" + _vm.color + "-dark)"),
    '--source-color-main': ("var(--" + _vm.color + "-main)"),
  })},[_c('div',{ref:"map",attrs:{"id":"map"}}),(_vm.$tvaMq !== 'mobile' && _vm.$tvaMq !== 'tablet')?_c('Top5',{staticClass:"map-container__top"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }